import { getToken } from 'functions/auth_check.js'

export function after (err) {
  if (err.response.status === 401) {
    VueRouter.replace('/logout/')
  }
  return Promise.reject(err)
}

export function before (config) {
  config.url = config.url + '?' + Date.now()
  config.headers.token = getToken()
  return config
}



// WEBPACK FOOTER //
// ./src/interceptors.js